import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer
      style={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        margin: 16,
        marginTop: 64,
      }}
    >
      <img
        src="logo.svg"
        alt="Code for Conservation Logo"
        style={{ marginTop: 64, width: 200 }}
      />
      <div style={{ display: "flex", flexDirection: "row", gap: 16 }}>
        <button
          style={{
            fontSize: 14,
            backgroundColor: "transparent",
            color: "#6E3224",
            fontFamily: "Roboto Serif",
            fontWeight: "normal",
          }}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            navigate("/imprint");
          }}
        >
          Imprint
        </button>
        <img
          src="bluesky.svg"
          alt="bluesky"
          style={{ width: 28, cursor: "pointer" }}
          onClick={() => {
            window.open(
              "https://bsky.app/profile/code4conservation.bsky.social"
            );
          }}
        />
      </div>
      <p style={{ fontSize: 14, marginTop: 16 }}>
        &copy; 2025 Code for Conservation. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
